module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_FR-3a75a0c0774b976dbe1bade0479d152e.svg";